import { DotsThreeIcon } from "@phosphor-icons/react/dist/csr/DotsThree";
import type { ReactNode } from "react";
import { Button } from "@volca/ui/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@volca/ui/components/ui/dropdown-menu";
import { Stack } from "@volca/ui/components/ui/stack";

export const ReviewHeading = ({
  children,
  actions,
}: {
  children: ReactNode;
  actions?: ReactNode;
}) => (
  <Stack direction="row" align="center" gap={1} className="shrink-0 px-2 pt-3">
    {children}
    {actions && (
      <DropdownMenu>
        <DropdownMenuTrigger
          render={
            <Button
              variant="ghost"
              size="icon-sm"
              aria-label="Period actions"
            />
          }
        >
          <DotsThreeIcon aria-hidden />
        </DropdownMenuTrigger>
        <DropdownMenuContent
          align="end"
          className="w-56 pointer-coarse:[&_[role^=menuitem]]:min-h-11"
        >
          {actions}
        </DropdownMenuContent>
      </DropdownMenu>
    )}
  </Stack>
);
